import { render, staticRenderFns } from "./JangsabotBanner.vue?vue&type=template&id=7ae9ade0&scoped=true&"
import script from "./JangsabotBanner.vue?vue&type=script&lang=js&"
export * from "./JangsabotBanner.vue?vue&type=script&lang=js&"
import style0 from "./JangsabotBanner.vue?vue&type=style&index=0&id=7ae9ade0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae9ade0",
  null
  
)

export default component.exports